import { ApiState } from '../../../utils/api-state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CreditHealthState } from './credit-health.reducer';

export const selectCreditHealthState = createFeatureSelector<ApiState<CreditHealthState>>('creditHealth');
export const selectCreditHealth = createSelector(selectCreditHealthState, (state) => state?.response);
export const selectCreditHealthLoading = createSelector(selectCreditHealthState, (state) => state?.processing);
export const selectCreditHealthLoaded = createSelector(selectCreditHealthState, (state) => state?.processed);
export const selectCreditHealthError = createSelector(selectCreditHealthState, (state) => state?.error);
export const selectCreditHealth200Error = createSelector(selectCreditHealth, (state) => state?.errorMessage);
